// Query

export type URLSearchParamsInitParams = ConstructorParameters<typeof URLSearchParams>[0];


// Sort

export interface SortableObjectWithSortOrderProp {
    sortOrder: number;
}

export interface SortableObjectWithSortProp {
    sort: number;
}


// Network

export enum HttpStatusCodeType {
    UNKNOWN,
    INFORMATIONAL,
    SUCCESSFUL,
    REDIRECTION,
    CLIENT,
    SERVER
}
